import { render, staticRenderFns } from "./fj1.vue?vue&type=template&id=1571b714&scoped=true&"
import script from "./fj1.vue?vue&type=script&lang=js&"
export * from "./fj1.vue?vue&type=script&lang=js&"
import style0 from "./fj1.vue?vue&type=style&index=0&id=1571b714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571b714",
  null
  
)

export default component.exports